import { useState, useEffect } from 'react';
import axios from 'axios';
import InstallationCard from './InstallationCard';
import Header from './Header';
import Footer from './Footer';
import AccessibilityWidget from './AccessibilityWidget';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InstallationGrid({ onRequestQuote, onOpenLeadForm, onOpenEstimateForm }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/products`).then(r => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="installation-page">
      <Header onOpenLeadForm={onOpenLeadForm} onOpenEstimateForm={onOpenEstimateForm} />
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12">
            <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
              Standard Installation
            </span>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-testid="installation-title">
              AC Installation Near Me - Licensed and Insured HVAC Installation
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto text-lg">
              Professional new AC unit installation near me with Goodman Heat Pump Systems, including all permits.<br />
              <strong className="text-red-600" data-testid="installation-warranty-text">10 Year Factory Warranty Included</strong>
            </p>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
              <span className="ml-3 font-medium text-gray-600">Loading Products...</span>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="installation-grid">
              {[...products].sort((a, b) => parseFloat(a.tonnage) - parseFloat(b.tonnage)).map(p => (
                <InstallationCard key={p.id} product={p} onRequestQuote={onRequestQuote} />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
      <AccessibilityWidget />
    </div>
  );
}
